export enum DayPeriodEnum {
  Am = 'am',
  Pm = 'pm',
}
